import { render, staticRenderFns } from "./Expert2RealEstateRequirementAdd.vue?vue&type=template&id=5ce45845&scoped=true&"
import script from "./Expert2RealEstateRequirementAdd.vue?vue&type=script&lang=js&"
export * from "./Expert2RealEstateRequirementAdd.vue?vue&type=script&lang=js&"
import style0 from "./Expert2RealEstateRequirementAdd.vue?vue&type=style&index=0&id=5ce45845&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ce45845",
  null
  
)

export default component.exports